import httpService from '@/services/httpService'
import { isEqual, uniqWith } from 'lodash'


export const types = {
  ADD_URL_DATA: 'url-census/ADD_URL_DATA',
  ADD_GEO_OPTIONS: 'url-census/ADD_GEO_OPTIONS',
  ADD_DEVICE_OPTIONS: 'url-census/ADD_DEVICE_OPTIONS',
  ADD_LOCALE_OPTIONS: 'url-census/ADD_LOCALE_OPTIONS',
  ADD_URL_ATTRIBUTES: 'url-census/ADD_URL_ATTRIBUTES',
  ADD_CB_URL: 'url-census/ADD_CB_URL',
  ADD_CLIENT_DEFAULT_RRT: 'url-census/ADD_CLIENT_DEFAULT_RRT',
  CHANGE_IS_SETTING_QUERIED_STATUS: 'url-census/CHANGE_IS_SETTING_QUERIED_STATUS',
  ADD_URL_EXAMPLES: 'url-census/ADD_URL_EXAMPLES',
  ADD_PAGE_TYPES: 'url-census/ADD_PAGE_TYPES',
  ADD_URL_STATUSES: 'url-census/ADD_URL_STATUSES',
  ADD_SECTIONS: 'url-census/ADD_SECTIONS',
  ADD_CONTENT_BRIEF_STATUSES: 'url-census/ADD_CONTENT_BRIEF_STATUSES',
  ADD_WRITING_STATUSES: 'url-census/ADD_WRITING_STATUSES',
  ADD_MSV_LABELS: 'url-census/ADD_MSV_LABELS',
  ADD_ATTRIBUTES: 'url-census/ADD_ATTRIBUTES',
  ADD_URL_LIST: 'url-census/ADD_URL_LIST',
  ADD_HTTP_STATUSES: 'url-census/ADD_HTTP_STATUSES',
  CHANGE_LAST_SELECTED_BULK_UPDATE_FIELD: 'url-census/CHANGE_LAST_SELECTED_BULK_UPDATE_FIELD',
  UPDATE_TABLE_FILTERS: 'url-census/UPDATE_TABLE_FILTERS'
}
const state = {
  geo: [],
  device: [],
  locale: [],
  isSettingsQueried: false,
  urlData: {},
  urlAttributes: [],
  contentBriefUrl: null,
  clientDefaultRRT: {},
  urlExamples: [],
  pageTypes: {},
  urlStatuses: {},
  sections: {},
  contentBriefStatuses: {},
  writingStatuses: {},
  msvLabels: {},
  attributes: {},
  urlList: [],
  httpStatuses: {},
  lastSelectedBulkUpdateField: 'urlStatuses',
  tableFilters: []
}

const mutations = {
  [types.ADD_URL_DATA]: function (state, urlData) {
    state.urlData = urlData
  },
  [types.ADD_CB_URL]: function (state, contentBriefUrl) {
    state.contentBriefUrl = contentBriefUrl
  },
  [types.ADD_GEO_OPTIONS]: function (state, geo) {
    state.geo = geo
  },
  [types.ADD_DEVICE_OPTIONS]: function (state, device) {
    state.device = device
  },
  [types.ADD_LOCALE_OPTIONS]: function (state, locale) {
    state.locale = locale
  },
  [types.ADD_URL_ATTRIBUTES]: function (state, urlAttributes) {
    state.urlAttributes = urlAttributes
  },
  [types.CHANGE_IS_SETTING_QUERIED_STATUS]: function (state) {
    state.isSettingsQueried = true
  },
  [types.ADD_CLIENT_DEFAULT_RRT]: function (state, clientDefaultRRT) {
    state.clientDefaultRRT = clientDefaultRRT
  },
  [types.ADD_URL_EXAMPLES]: function (state, urlExamples) {
    state.urlExamples = urlExamples
  },
  [types.ADD_PAGE_TYPES]: function (state, pageTypes) {
    state.pageTypes = pageTypes
  },
  [types.ADD_URL_STATUSES]: function (state, urlStatuses) {
    state.urlStatuses = urlStatuses
  },
  [types.ADD_SECTIONS]: function (state, sections) {
    state.sections = sections
  },
  [types.ADD_CONTENT_BRIEF_STATUSES]: function (state, contentBriefStatuses) {
    state.contentBriefStatuses = contentBriefStatuses
  },
  [types.ADD_WRITING_STATUSES]: function (state, writingStatuses) {
    state.writingStatuses = writingStatuses
  },
  [types.ADD_MSV_LABELS]: function (state, msvLabels) {
    state.msvLabels = msvLabels
  },
  [types.ADD_ATTRIBUTES]: function (state, attributes) {
    state.attributes = attributes
  },
  [types.ADD_URL_LIST]: function (state, urlList) {
    state.urlList = urlList
  },
  [types.ADD_HTTP_STATUSES]: function (state, httpStatuses) {
    state.httpStatuses = httpStatuses
  },
  [types.CHANGE_LAST_SELECTED_BULK_UPDATE_FIELD]: function (state, lastSelectedBulkUpdateField) {
    state.lastSelectedBulkUpdateField = lastSelectedBulkUpdateField
  },
  [types.UPDATE_TABLE_FILTERS]: function (state, tableFilters) {
    state.tableFilters = tableFilters
  }
}

const actions = {
  async getUrlTargetingSettings ({ commit }, clientId) {
    const response = await httpService.get(`/clients/settings/${clientId}`)
    if (!response || !response.data) {
      commit(types.ADD_GEO_OPTIONS, [])
      commit(types.ADD_DEVICE_OPTIONS, [])
      commit(types.ADD_LOCALE_OPTIONS, [])
      commit(types.ADD_CLIENT_DEFAULT_RRT, {})
      commit(types.ADD_URL_EXAMPLES, {})
      return {}
    }
    commit(types.CHANGE_IS_SETTING_QUERIED_STATUS)
    commit(types.ADD_GEO_OPTIONS, response.data.geo)
    commit(types.ADD_DEVICE_OPTIONS, response.data.device)
    commit(types.ADD_LOCALE_OPTIONS, response.data.locale)
    commit(types.ADD_CLIENT_DEFAULT_RRT, response.data.client_default_rrt)
    commit(types.ADD_URL_EXAMPLES, response.data.url_examples)
    return response.data
  },
  async getDataByUrlId ({ commit }, urlId) {
    const response = await httpService.get(`/url/${urlId}`)
    if (!response || !response.data) {
      commit(types.ADD_URL_DATA, {})
      commit(types.ADD_URL_ATTRIBUTES, [])
      commit(types.ADD_CB_URL, null)
      return {}
    }
    commit(types.ADD_URL_DATA, response.data.data)
    commit(types.ADD_URL_ATTRIBUTES, response.data.url_attributes)
    commit(types.ADD_CB_URL, response.data.cb_url)
    return response.data
  },
  async removeUrlById ({ commit }, urlId) {
    const response = await httpService.delete(`/url/${urlId}`, { successMessage: 'URL removed successfully', raiseError: true })
    if (!response || !response.data) {
      return {}
    }
    return response.data
  },
  async createUpdateUrl ({ commit }, { urlData, urlId, method }) {
    const request = httpService[method]
    const response = await request(`/url/${urlId}`, { url_data: urlData })
    if (!response || !response.data) {
      return false
    }
    commit(types.ADD_CB_URL, response.data.cb_url)
    return response.data
  },
  async resetUrlData ({ commit }) {
    commit(types.ADD_URL_DATA, {})
    commit(types.ADD_URL_ATTRIBUTES, [])
    commit(types.ADD_CB_URL, null)
  },
  async getUrlOpts ({ commit, dispatch }, clientId) {
    const response = await httpService.get(`/url-census/url-opts/${clientId}`)
    return response.data
  },
  async getSourceOpts ({ commit, dispatch }) {
    const response = await httpService.get('/url-census/source-opts')
    return response.data
  },
  async getUrlTableHelpers ({ commit, dispatch }, clientId) {
    const response = await httpService.get(`/url-census/url-table-helpers/${clientId}`)
    if (!response || !response.data) {
      return {}
    }

    commit(types.ADD_PAGE_TYPES, response.data.page_types)
    commit(types.ADD_URL_STATUSES, response.data.url_statuses)
    commit(types.ADD_SECTIONS, response.data.sections)
    commit(types.ADD_CONTENT_BRIEF_STATUSES, response.data.content_brief_statuses)
    commit(types.ADD_WRITING_STATUSES, response.data.writing_statuses)
    commit(types.ADD_MSV_LABELS, response.data.msv_labels)
    commit(types.ADD_ATTRIBUTES, response.data.attributes)
    commit(types.ADD_URL_LIST, response.data.urls)
    commit(types.ADD_HTTP_STATUSES, response.data.http_statuses)
    return response.data
  },
  async postBulkUpdate ({ commit, dispatch }, { clientId, form }) {
    form = JSON.stringify(form)
    return httpService.post(`/url-census/bulk-update/${clientId}`, { form },
      { successMessage: 'URLs successfully updated', raiseError: true })
  },
  async postUrls ({ commit, dispatch }, { clientId, form }) {
    // form = JSON.stringify(form)
    // return httpService.post(`/url-census/urls/${clientId}`, { form },
    //  { successMessage: 'URLs successfully created', raiseError: true })
  },
  async updateField ({ commit, dispatch }, { form }) {
    form = JSON.stringify(form)
    return httpService.patch('/url-census/update-field', { form },
      { successMessage: 'Item successfully updated', raiseError: false })
  },
  async getFilterFields ({ commit, dispatch }, { clientId, data }) {
    const params = { data: JSON.stringify(data) }
    return httpService.get(`/url-census/filter-data/${clientId}`, { params })
  },
  changeLastSelectedBulkUpdateField ({ commit }, lastSelectedBulkUpdateField) {
    commit(types.CHANGE_LAST_SELECTED_BULK_UPDATE_FIELD, lastSelectedBulkUpdateField)
  },
  updateTableFilters ({ commit }, { advancedFilters, headerFilters }) {
    headerFilters = headerFilters.map(filter => ({ ...filter, isHeaderFilter: true }))
    advancedFilters = advancedFilters.map(filter => ({ ...filter, isHeaderFilter: false }))
    let tableFilters = [...advancedFilters, ...headerFilters]
    tableFilters = tableFilters.reduce((previous, current) => {
      // filter must have all fields set
      const filterIsMissingFields = !current.field || !current.type || !current.value
      const valueIsEmptyArray = Array.isArray(current.value) && !current.value.length
      if (filterIsMissingFields || valueIsEmptyArray) {
        return previous
      }
      // clean up into consistent object
      current = {
        field: current.field,
        type: current.type,
        value: current.value,
        isHeaderFilter: current.isHeaderFilter
      }
      // 'in' filters must have values of type Array
      if (current.type === 'in' && !Array.isArray(current.value)) {
        current.value = current.value.split(',').map(val => val.trim())
      }

      if (current.type === 'in') {
        for (let i = 0; i < current.value.length; i++) {
          const newFilter = {
            field: current.field,
            type: 'in',
            value: [current.value[i]],
            isHeaderFilter: current.isHeaderFilter
          }
          const exists = previous.some(obj => isEqual(obj, newFilter))
          if (!exists) {
            previous.push(newFilter)
          }
        }
      }
      // remove duplicates
      const includesFilter = previous.some(obj => isEqual(obj, current))
      if (current.type !== 'in' && !includesFilter) {
        previous.push(current)
      }
      return previous
    }, [])

    advancedFilters = tableFilters.filter(filter => !filter.isHeaderFilter)
    tableFilters = tableFilters.filter(filter => filter.isHeaderFilter)
    advancedFilters.forEach(filter => {
      const filterExists = tableFilters.some(obj => {
        return isEqual({ ...obj, isHeaderFilter: null }, { ...filter, isHeaderFilter: null })
      })
      if (!filterExists) {
        tableFilters.push(filter)
      }
    })

    commit(types.UPDATE_TABLE_FILTERS, tableFilters)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
